import { useEffect } from 'react';

import { CustomCampaignSteps } from 'domains/campaigns/components/CustomCampaign/CustomCampaign';
import { CampaignStateTypes } from 'domains/campaigns/components/CustomCampaign/customCampaignReducer';
import { SplitTypes } from 'domains/campaigns/types';

type Props = {
    activeSendIndex: number;
    campaignState: CampaignStateTypes;
    dispatchCampaignAction: React.Dispatch<any>;
    setActiveSendIndex: (index: number) => void;
    setActiveStep: (step: CustomCampaignSteps) => void;
};

const CustomCampaignRandomSplitStep = ({
    activeSendIndex,
    campaignState,
    setActiveSendIndex,
    setActiveStep,
}: Props): null => {
    useEffect(() => {
        const groupASendIndex = campaignState.sends.findIndex(
            (send: any) => send.splitType === SplitTypes.RANDOM_GROUP_1 && send.parentIndex === activeSendIndex
        );
        if (groupASendIndex !== -1) {
            setActiveSendIndex(groupASendIndex);
            setActiveStep(CustomCampaignSteps.SELECT_PATH_ACTION);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default CustomCampaignRandomSplitStep;
